import React from 'react'
import { Outlet } from 'react-router-dom'


const Content = ({ sidebarVisible }) => {

  return (
    <div   className={`lg:w-[70%] w-full transition-all duration-500 ease-in-out flex-1 h-auto lg:mx-[2rem] px-2 pt-[5rem] lg:mb-[4rem] ${
      sidebarVisible ? "lg:ml-[16.5rem] ml-0" : "lg:ml-[5rem]"
    }`}>
       <Outlet />
 
    </div>
  
  )
}

export default Content